import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { PackElite } from './components/PackElite';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-800 selection:bg-aqua-200 selection:text-aqua-900" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Tomos data-id="element-6" />
      <Bonos data-id="element-7" />
      <CountdownTimer data-id="element-8" />
      <PricingSection data-id="element-9" />
      <PackElite data-id="element-10" />
      <ExtendedTestimonials data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <CostComparison data-id="element-14" />
      <CountdownTimer data-id="element-15" />
      <PricingSection data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}